import { TooltipDesktop } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { LinkWrapper } from '../../common/components/link_wrapper';
import { Tag } from '../../common/components/tag';
import { IUserLevelInfoSchema } from '../../repositories/offer-card/entities/agent/UserLevelInfoSchema';
import { getAgentType } from '../../utils/getAgentType';
import { getProofMessage } from '../../utils/getProofMessage';
import { WorkHonestlyTooltip } from '../WorkHonestlyTooltip';
import * as styles from './index.css';

export interface IUserWorkHonestlyInfoProps {
  agentLevelInfo: IUserLevelInfoSchema;
  isAgentPublished?: boolean;
  nameHandler?: () => void;
  profileLink?: string;
  agentName?: string;
  isProAgent?: boolean;
  agent: IAgentSchema;
}

export const UserWorkHonestlyInfo = ({
  agentLevelInfo,
  isAgentPublished,
  nameHandler,
  profileLink,
  agentName,
  isProAgent,
  agent,
}: IUserWorkHonestlyInfoProps) => {
  const { levelName, levelOrder, hasVerifiedDocuments } = agentLevelInfo;
  const agentType = React.useMemo(() => getAgentType(agent), [agent]);
  const message = React.useMemo(() => getProofMessage(agentType), [agentType]);

  if (!levelOrder || !levelName) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['link-wrapper']}>
        {isAgentPublished ? (
          <LinkWrapper target="_blank" href={profileLink} onClick={nameHandler} className={styles['title-link']}>
            <div className={styles['title-wrapper']}>
              <h2 className={styles['title-container']}>
                <span className={styles['title']}>{agentName}</span>
                {levelOrder > 2 && (
                  <TooltipDesktop
                    title={<WorkHonestlyTooltip levelNumber={levelOrder} levelName={levelName} />}
                    theme="white"
                    placement="right"
                  >
                    <div className={classNames(styles['title-icon'], styles[`title-icon-${levelOrder}`])} />
                  </TooltipDesktop>
                )}
                {isProAgent && (
                  <Tag className={styles['tag-pro']} title="Профессиональный пользователь">
                    Pro
                  </Tag>
                )}
              </h2>
            </div>
          </LinkWrapper>
        ) : (
          <div className={styles['title-wrapper']}>
            <h2 className={styles['title-container']}>
              <span className={styles['title']}>{agentName}</span>
              {levelOrder > 2 && (
                <TooltipDesktop
                  title={<WorkHonestlyTooltip levelNumber={levelOrder} levelName={levelName} />}
                  theme="white"
                  placement="right"
                >
                  <div className={classNames(styles['title-icon'], styles[`title-icon-${levelOrder}`])} />
                </TooltipDesktop>
              )}
              {isProAgent && (
                <Tag className={styles['tag-pro']} title="Профессиональный пользователь">
                  Pro
                </Tag>
              )}
            </h2>
          </div>
        )}
      </div>
      {hasVerifiedDocuments && (
        <div className={styles['doc-approves-container']}>
          <div className={styles['doc-approves-icon']} />
          <div className={styles['doc-approves-title']}>{message}</div>
        </div>
      )}
    </div>
  );
};
